
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/videos/[video_id]",
      function () {
        return require("private-next-pages/videos/[video_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/videos/[video_id]"])
      });
    }
  